import React from 'react'

const Sponsor = ({ size, logo, logoLink }) => {
  const colSize = () => {
    switch (size) {
      case 'large':
        return 'col-xs-6 col-sm-4'
      case 'medium':
        return 'col-xs-6 col-sm-3'
      case 'small':
        return 'col-xs-6 col-sm-2'
      default:
        return ''
    }
  }

  const link = () => (logoLink ? logoLink : '#')

  return (
    <div className={colSize()}>
      <div className='box'>
        <a href={link()}>
          <img className='img-responsive center-margin' src={logo.large.url} alt='logo' />
        </a>
      </div>
    </div>
  )
}

export default Sponsor
